export default {
  'securityEvents.title': 'SIEM (Gestión de Información y Eventos de Seguridad)',
  'securityEvents.column.scope': 'Alcance',
  'securityEvents.column.categories': 'Categorías',
  'securityEvents.column.destinations': 'Destinos',
  'securityEvents.column.readyDestinations': 'Destinos Ready y activos',
  'securityEvents.column.effective': 'Efectiva',
  'securityEvents.column.connector': 'Conector',
  'securityEvents.categories.all': 'Todos los eventos',
  'securityEventCategory.authentication': 'Clasificación de autenticación',
  'securityEventCategory.admin': 'Administración',
  'securityEventCategory.auth': 'Autenticación',
  'securityEventCategory.environment': 'Entorno',
  'securityEventCategory.process': 'Proceso',
  'securityEventCategory.role': 'Roles',
  'securityEventCategory.user': 'Usuarios',
  'securityEventScopeCategory.global': 'Compañía',
  'securityEventScopeCategory.scoped': 'Con alcance',
  'securityEventScopeType.environment': 'Entorno',
  'siemConnectorType.genericHttps': 'Generic HTTPS',
  'siemConnectorType.splunkHec': 'Splunk HEC',
  'siemConnectorType.eventHub': 'Azure Event Hub',
  'siemDestinationStatus.incomplete': 'Incompleto',
  'siemDestinationStatus.ready': 'Ready',
  'siemDestinationAuthorizationType.noAuth': 'Sin Autenticación',
  'siemDestinationAuthorizationType.apiKeyInHeader': 'API Key - En Cabecera',
  'siemDestinationAuthorizationType.apiKeyInQueryParameters': 'API Key - En Url',
  'siemDestinationAuthorizationType.bearerToken': 'Token Bearer',
  'siemDestinationAuthorizationType.basicAuth': 'Autenticación Básica',
  'securityEvents.delivery.effective': 'Efectiva',
  'securityEvents.delivery.missingDestination': 'Sin destino efectivo',
  'securityEvents.delivery.inactive': 'Inactiva',
  'securityEvents.action.destinations': 'Destinos',
  'securityEvents.action.test': 'Probar conexión',
  'securityEvents.field.url': 'URL',
  'securityEvents.field.keyName': 'Nombre de la API key',
  'securityEvents.field.keyValue': 'Valor de la API key',
  'securityEvents.field.endpoint': 'Endpoint HEC',
  'securityEvents.field.hecToken': 'Token HEC',
  'securityEvents.field.index': 'Índice',
  'securityEvents.field.source': 'Origen',
  'securityEvents.field.sourceType': 'Tipo de origen',
  'securityEvents.field.connectionString': 'Cadena de conexión',
  'securityEvents.field.eventHubName': 'Nombre del Event Hub',
  'securityEvents.secret.stored': 'Guardado',
  'securityEvents.validation.https': 'La dirección debe usar HTTPS',
  'securityEvents.validation.eventHubName':
    'Usa el nombre del hub en Azure: letras, números, punto, guion o guion bajo.',
  'securityEvents.destination.needsTest':
    'Este destino está incompleto. Guarde y pruebe la conexión para que pueda entregar eventos.',
  'securityEvents.destination.retest':
    'La configuración cambió. Hay que probar la conexión otra vez para que el destino vuelva a estar Ready.',
  'securityEvents.destinations.title': 'Destinos',
  'securityEvents.destinations.description': 'Destinos de {name}',
  'securityEvents.delete.subscription':
    'Se borrará la suscripción y también todos sus destinos. Esta acción no se puede deshacer.',
  'securityEvents.action.operational': 'Estado operativo',
  'securityEvents.operational.title': 'Estado operativo',
  'securityEvents.operational.description': 'Actividad observada de {name}',
  'securityEvents.operational.observed': 'Actividad observada — últimas 24 horas',
  'securityEvents.operational.window': '{start} – {end}',
  'securityEvents.operational.projectionStarted': 'Proyección desde {date}',
  'securityEvents.operational.partial': 'Vista parcial de actividad observada',
  'securityEvents.operational.truncated':
    '{included} de {total} destinos incluidos; counters de los destinos mostrados',
  'securityEvents.operational.notInitialized':
    'Todavía no hay cobertura operacional para esta ventana',
  'securityEvents.operational.unavailable': 'No fue posible leer la actividad observada',
  'securityEvents.operational.noDestinations': 'No hay destinos configurados',
  'securityEvents.operational.operation': 'Operación',
  'securityEvents.operational.lastActivity': 'Última actividad',
  'securityEvents.operational.lastSuccess': 'Último éxito',
  'securityEvents.operational.lastFailure': 'Último fallo',
  'securityEvents.operational.lastAttempt': 'Último intento',
  'securityEvents.operational.attempts': 'Intentos',
  'securityEvents.operational.recentLimit': 'Filas recientes',
  'securityEvents.operational.viewDestination': 'Ver actividad',
  'securityEvents.operational.safeError': 'Código seguro',
  'securityEvents.operational.httpStatus': 'HTTP',
  'securityEvents.operational.noRecentActivityHint': 'No se observó actividad operacional reciente',
  'securityEvents.operational.awaitingDeliveryHint': 'Actividad observada sin resultado confirmado',
  'siemDeliveryStatus.pending': 'Pendiente',
  'siemDeliveryStatus.sending': 'Sending / procesamiento pendiente',
  'siemDeliveryStatus.delivered': 'Entregado',
  'siemDeliveryStatus.failed': 'Fallido',
  'siemDeliveryStatus.deadLetter': 'No entregable',
  'siemDerivedOperationalStatus.disabled': 'Deshabilitado',
  'siemDerivedOperationalStatus.incomplete': 'Incompleto',
  'siemDerivedOperationalStatus.noRecentActivity': 'Sin actividad observada',
  'siemDerivedOperationalStatus.failing': 'Con fallos',
  'siemDerivedOperationalStatus.degraded': 'Degradado',
  'siemDerivedOperationalStatus.operational': 'Operativo',
  'siemDerivedOperationalStatus.awaitingDelivery': 'Entrega pendiente',
  'securityEvents.error.timeout': 'Tiempo de espera agotado',
  'securityEvents.error.network': 'Error de red',
  'securityEvents.error.redirect-blocked': 'Redirección bloqueada',
  'securityEvents.error.invalid-configuration': 'Configuración no válida',
  'securityEvents.error.company-mismatch': 'La compañía no coincide',
  'securityEvents.error.unsupported-connector': 'Conector no soportado',
  'securityEvents.error.destination-missing': 'Destino inexistente',
  'securityEvents.error.destination-inactive': 'Destino inactivo',
  'securityEvents.error.destination-not-ready': 'Destino no está Ready',
  'securityEvents.error.blob-unreadable': 'No se pudo leer el contenido',
  'securityEvents.error.unauthorized': 'No autorizado',
  'securityEvents.error.resource-not-found': 'Recurso no encontrado',
  'securityEvents.error.message-too-large': 'Mensaje demasiado grande',
  'securityEvents.error.service-busy': 'Servicio ocupado',
  'securityEvents.error.invalid-response': 'Respuesta no válida',
  'securityEvents.error.splunk-hec-rejected': 'Splunk HEC rechazó el envío',
  'securityEvents.error.splunk-ack-unsupported': 'Splunk no admite la confirmación',
  'securityEvents.error.http': 'HTTP {status}',
  'securityEvents.error.unknown': 'Fallo observado; detalle seguro no disponible',
};
